// store.js
import { reactive } from 'vue';

export const store = reactive({
  prevRoute: null
});

export const setStore = (key: string, value: any) => {
    store[key] = value
}
